// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2447":"css/app.6939","6702":"css/admin-app.6939"}[chunkId] + ".css";
};